import { findAndReplace } from "mdast-util-find-and-replace";
import type { PhrasingContent, Root } from "mdast";

const SPOILER_REGEX = /\|\|(.+?)\|\|/g;

/**
 * Remark plugin that transforms ||spoiler|| syntax into hast-compatible
 * inline nodes rendered as <span class="spoiler" data-spoiler="true">.
 *
 * This replaces the old approach of injecting raw <spoiler> HTML and
 * parsing it back with rehype-raw + rehype-sanitize.
 */
export default function remarkSpoiler() {
  return (tree: Root) => {
    findAndReplace(tree, [[SPOILER_REGEX, replaceSpoiler]]);
  };
}

function replaceSpoiler(_match: string, content: string): PhrasingContent {
  // "spoiler" is a custom mdast extension node, not part of the standard
  // PhrasingContent union. It is rendered to HTML purely via `data.hName` /
  // `data.hProperties` by the rehype pipeline, so the runtime contract is
  // satisfied even though the node type is not a built-in mdast type. We cast
  // to PhrasingContent because findAndReplace's ReplaceFunction requires it.
  return {
    type: "spoiler",
    data: {
      hName: "span",
      hProperties: { className: ["spoiler"], "data-spoiler": "true" },
    },
    children: [{ type: "text", value: content }],
  } as unknown as PhrasingContent;
}
